import script from "./LottieLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./LottieLoader.vue?vue&type=script&setup=true&lang=js"

import "./LottieLoader.vue?vue&type=style&index=0&id=2ffe4aa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffe4aa1"]])

export default __exports__